// COMPONENT IMPORTS
import { apiInstance } from "store/api/axiosApi";
import { COUNTRY_STATE, DOWNLOAD_ATTACHMENT, GET_ATTACHMENT_LIST } from "store/api/constApi";

/* ------------------------------------- DOCUMNET SERVICES ------------------------------------- */

export const getAttachmentList = (params: any) => {
  return apiInstance.get(GET_ATTACHMENT_LIST, { params });
};

export const downloadAttachment = (params: any) => {
  return apiInstance.get(DOWNLOAD_ATTACHMENT, { params });
};

export const getCountryAndState = () => {
  return apiInstance.get(COUNTRY_STATE);
};